import React, { memo } from 'react'

export const ColumnHeader = memo(() => {
  return (
    <div
      className={
        'relative px-10 pt-10 lg:pt-[54px] pb-8 lg:pb-10 overflow-hidden'
      }
    >
      <div className={'max-w-[1006px] mx-auto relative z-10'}>
        <h1
          className={
            'text-center text-2xl lg:text-[57.65px] leading-normal font-bold'
          }
        >
          コラム
        </h1>
        <p
          className={
            'flex justify-center lg:text-center text-sm lg:text-lg leading-[1.7] mt-2 lg:mt-[23px]'
          }
        >
          様々な文書の作成・検索・レビューを効率化する方法を
          <br />
          実際の使用例をあげながら説明します。
        </p>
        <img
          src="/images/img_contact.svg"
          alt=""
          className={
            'absolute right-[-34px] lg:right-0 top-[58px] lg:top-[28px] w-[78px] lg:w-auto'
          }
        />
      </div>
      <img
        src="/images/bg_intro_column01.webp"
        alt=""
        className={'absolute top-0 left-0 w-full h-full object-cover'}
      />
    </div>
  )
})

ColumnHeader.displayName = 'ColumnHeader'
